const DEST_IMAGES = {
  'hyderabad': 'photo-1599661046289-e31897846e41',
  'rishikesh': 'photo-1544367567-0f2fcb009e0b',
  'bali': 'photo-1537996194471-e657df975ab4',
  'tokyo': 'photo-1540959733332-eab4deabeeaf',
  'santorini': 'photo-1613395877344-13d4a8e0d49e',
  'machu picchu': 'photo-1587595431973-160d0d94add1',
  'paris': 'photo-1502602898657-3e91760cbb34',
  'safari': 'photo-1516426122078-c23e76319801',
  'maldives': 'photo-1514282401047-d79a71a590e8',
  'swiss alps': 'photo-1531366936337-7c912a4589a7',
  'bangkok': 'photo-1508009603885-50cf7c579365',
  'ibiza': 'photo-1539037116277-4db20889f2d4',
  'dubai': 'photo-1512453979798-5ea266f8880c',
  'utah': 'photo-1506905925346-21bda4d32df4',
  'zion': 'photo-1506905925346-21bda4d32df4',
  'india': 'photo-1544367567-0f2fcb009e0b',
  'indonesia': 'photo-1537996194471-e657df975ab4',
  'japan': 'photo-1540959733332-eab4deabeeaf',
  'greece': 'photo-1613395877344-13d4a8e0d49e',
  'peru': 'photo-1587595431973-160d0d94add1',
  'france': 'photo-1502602898657-3e91760cbb34',
  'kenya': 'photo-1516426122078-c23e76319801',
  'switzerland': 'photo-1531366936337-7c912a4589a7',
  'thailand': 'photo-1508009603885-50cf7c579365',
  'spain': 'photo-1539037116277-4db20889f2d4',
  'uae': 'photo-1512453979798-5ea266f8880c',
};

const GENERIC_TRAVEL = 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&h=280&fit=crop';

export function getTripImageByDestination(destination) {
  const dest = (destination || '').toLowerCase();
  for (const [key, photoId] of Object.entries(DEST_IMAGES)) {
    if (dest.includes(key)) {
      return `https://images.unsplash.com/${photoId}?w=400&h=280&fit=crop`;
    }
  }
  return GENERIC_TRAVEL;
}

export function tripImage(trip) {
  if (trip?.coverImage) return trip.coverImage;
  if (trip?.imgUrl) return trip.imgUrl;
  const dest = (trip?.destination || trip?.dest || '').toLowerCase();
  for (const [key, photoId] of Object.entries(DEST_IMAGES)) {
    if (dest.includes(key)) {
      return `https://images.unsplash.com/${photoId}?w=400&h=280&fit=crop`;
    }
  }
  return GENERIC_TRAVEL;
}

export { DEST_IMAGES, GENERIC_TRAVEL };
